"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigProvider = ConfigProvider;
exports.MockProvider = void 0;
exports.useConfig = useConfig;
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
var _axios = _interopRequireDefault(require("axios"));
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var defaults = _interopRequireWildcard(require("./defaults"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// $FlowFixMe
const Context = /*#__PURE__*/(0, _react.createContext)({});

/**
 * Returns a config value (or group of config values) for the configuration group that was declared
 * in a parent parent context `ConfigProvider`.
 */
function useConfig(path) {
  const config = (0, _react.useContext)(Context);
  if (Array.isArray(path)) {
    return path.map(p => getValueWithWarning(config, p));
  }
  return getValueWithWarning(config, path);
}
/**
 * Sets up a context and loads the data for the given configuration group.
 */
function ConfigProvider({
  children,
  group
}) {
  const [config, setConfig] = (0, _react.useState)(defaults[group] || {});
  (0, _react.useEffect)(() => {
    async function fetchConfiguration() {
      try {
        const {
          data
        } = await _axios.default.get(`/configuration/${group}`);
        if (data) {
          const {
            stage
          } = data;
          if (data.stage === 'development') console.warn(`❗ Loading ${group} configuration for stage='development'`);
          setConfig({
            ...config,
            ...data
          });
        }
      } catch (error) {
        try {
          throw new UseConfigHookError(`Error loading ConfigProvider: ${error}`);
        } catch (e) {
          (0, _utils.captureSentryException)(e, 'Configuration error: ', [{
            Config: config,
            Group: group
          }]);
        }
      }
    }
    fetchConfiguration();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [group]);
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: config
  }, children);
}

/**
 * Export the provider so it can used in tests.
 */
const MockProvider = Context.Provider;

//
// Private functions
// -------------------------------------------------------------------------------------------------
exports.MockProvider = MockProvider;
class UseConfigHookError extends Error {
  constructor(...params) {
    super(...params);
    this.name = 'UseConfigHookError';
  }
}
function getValueWithWarning(config, path) {
  const value = (0, _lodash.get)(config, path, null);
  if (value === null) console.warn(`%c😬 Returning null for config path '${path}'!`, 'font-weight: bold');
  return value;
}